import { Hexagen } from "../types";
import { CardImage } from "./CardImage";
import { useState } from "react";

type SmallCardProps = {
  hexagenInfo: Hexagen;
  withZoom?: boolean;
};

export const SmallCard: React.FC<SmallCardProps> = ({
  hexagenInfo,
  withZoom = true,
}) => {
  const [mouseOffset, setMouseOffset] = useState({
    x: 0,
    y: 0,
  });
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const x = e.clientX - rect.left - centerX;
    const y = e.clientY - rect.top - centerY;

    const normalizedX = x / centerX;
    const normalizedY = y / centerY;

    setMouseOffset({
      x: -x * 0.15,
      y: -y * 0.15,
    });

    setRotation({
      x: -normalizedY * 15,
      y: normalizedX * 15,
    });
  };

  const handleMouseLeave = () => {
    setMouseOffset({
      x: 0,
      y: 0,
    });
    setRotation({ x: 0, y: 0 });
    setIsHovered(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  return (
    <div
      className="w-full h-full relative inline-block cursor-pointer select-none"
      style={{
        perspective: "800px",
        transformStyle: "preserve-3d",
        transform: withZoom && isHovered ? "scale(1.2)" : "scale(1)",
        transition: "transform 0.3s ease-out",
        transformOrigin: "center center",
        zIndex: isHovered ? 10 : 1,
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      <div
        className="w-full h-full"
        style={{
          transform: withZoom
            ? `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`
            : "none",
          transition: "transform 0.15s ease-out",
          transformStyle: "preserve-3d",
          transformOrigin: "center center",
          boxShadow: isHovered ? "0 0 20px 2px rgba(0, 0, 0, 0.5)" : "none",
        }}
      >
        <div
          className="w-full h-full overflow-hidden relative"
          style={{
            transformStyle: "preserve-3d",
          }}
        >
          <div
            className="w-[220px] h-[280px] overflow-hidden absolute top-[-110px] left-[-60px]"
            style={{
              transform: `translate(${mouseOffset.x}px, ${mouseOffset.y}px)`,
              transition: "transform 0.15s ease-out",
            }}
          >
            <CardImage
              x={hexagenInfo.x}
              y={hexagenInfo.y}
              hideShadow
              imageGeneratedAt={
                hexagenInfo.regeneratedAt || hexagenInfo.createdAt
              }
              imageVersion={hexagenInfo.cardVersion}
            />
          </div>
        </div>
        <div className="absolute top-0 left-0 bg-black text-white py-[4px] pr-2 pl-[3px] text-xs select-none">
          <span title="Creativity score">score {hexagenInfo.points}</span>{" "}
          <span title="Upvotes">♥ {hexagenInfo.upvotes}</span>
        </div>
      </div>
    </div>
  );
};
